import React from 'react';
import IsHeMineLogo from "../Assets/light-logo.png"

const LightLogo = () => {
  return (
    <img src={IsHeMineLogo} alt="Logo" className="h-8 cursor-pointer" />
  );
};

export default LightLogo;